<section *ngIf="showChoiceAuthorizationType" class="container">
  <app-choice-partner-type (eventEmployee)="onExistUser()" (eventGuest)="onGuestUser()"></app-choice-partner-type>
</section>
<section *ngIf="showScanPartnerCode" class="container">
  <app-partner-code-scan (scanPartnerCode)="onScanPartnerCode($event)" (eventBack)="onBack()">
  </app-partner-code-scan>
</section>
<app-login-payment *ngIf="showLoginForm" (eventLoggedIn)="onLogin()" (eventRegister)="register()"
  (eventRegisterAsGuest)="onRegisterAsGuest()" (eventBack)="onBack()" [showGuestRegister]="allowGuestAuthorization" [fullSize]="true"
  [showBack]="true" [showRegistrationUrl]="allowedRegistration" [email]="scanPartnerCodeInfo?.partner?.email"
  [readOnlyEmail]="!!scanPartnerCodeInfo?.partner?.email" [showRememberMe]="!scanPartnerCodeInfo?.partner?.email">
</app-login-payment>
<app-partner-registration-form *ngIf="showRegistrationForm" #partnerRegistrationForm
  (eventRegister)="onRegister(partnerRegistrationForm)" [showBack]="true" (eventBack)="onBack()"
  (eventLogin)="switchToLogin()" [fullSize]="true" [showPassword]="true" [showLoginUrl]="!partnerCodeEnabled">
</app-partner-registration-form>
